import { useContext, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { apiUrl } from "./delcare"
import { AppContext } from "./context"

const Authentication = () => {

    let { fetchData, neonUser, token, fetchDataV2 } = useContext(AppContext)

    const [params, setParams] = useSearchParams()
    let [allParams, setAllParams] = useState({})
    let [authUrl, setAuthUrl] = useState("")
    let [error, setError] = useState(null)
    let [profile, setProfile] = useState({})

    const getProfile = async () => {


        // let resp = await fetchData('SELECT * FROM client_profile_info WHERE id = ' + allParams.profile_id, "/neon-market")

        let query1 = "AUTH_GET_PROFILE", params1 = [allParams.profile_id]

        let resp = await fetchDataV2(query1, params1, "/neon-market-v2")

        if (!resp || resp.length == 0) {
            setAuthUrl("ERROR PROFILE NOT FOUND")
            setError(true)
            return
        }

        setProfile(resp[0])
        return
    }

    const getAuthUrl = async () => {
        let url = apiUrl + `/amazon_code?state=${profile.client_authorisation_id}_._${profile.id}_._${allParams.goback || window.location.origin}`
        console.log("GET AUTH URL", url)
        try {
            let resp = await fetch(url, {
                method: "GET",
                headers: (() => {
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("Authorization", `Bearer ${token.accessToken}`)
                    return myHeaders
                })()
            })

            if (!resp.ok) {
                console.log("GET AUTH ERROR RESPONSE", resp)
                setAuthUrl("ERROR")
                setError(true)
                return
            }

            resp = await resp.text()

            setAuthUrl((resp))
            setError(false)
        }
        catch (err) {
            console.log("ERROR IN GET AUTH URL", err)
            setAuthUrl("ERROR")
            setError(true)
            return
        }



    }

    useEffect(() => {
        if (error == false && !!authUrl) window.location.href = authUrl
    }, [error, authUrl])

    useEffect(() => {
        console.log("PROFILE INFO", profile)
        if (profile.id) getAuthUrl()
    }, [profile])

    useEffect(() => {
        console.log({ allParams })
        if (allParams.profile_id && !!neonUser.user_id) getProfile()
    }, [allParams, neonUser])

    useEffect(() => {
        let getParams = {}
        for (const [key, value] of params.entries()) {
            getParams = { ...getParams, [key]: value }
        }
        getParams = { ...getParams, state: crypto.randomUUID() }
        setAllParams(getParams)
    }, [])


    return (
        <>
            <p>authenticating...</p>
            {authUrl && !error ? <a href={authUrl}>{authUrl}</a> : authUrl}
        </>

    )
}

export default Authentication